module.exports = __webpack_public_path__ + "components/country-flag/static/jp-c415dba06888155de25738503c5f49c1.svg";